
import Dialog from '../Dialog.vue'

// TODO: loading bar

export default {
	name: 'JsonAutotestTimeline',
	components: { Dialog },
	inject: [ 'defaultLocale', 'eventBus' ],
	props: {
		testcase: Object,
		target: Object,
		runner: String,
		value: Object, // { fromDate, toDate, interval }
		showScale: Boolean,
	},
	data: () => ({
		slaData: null,
		executionData: null,
		nightStart: 21,
		nightEnd: 6,
		activeExecution: null,
		hoveredExecution: null,
		clickedExecution: null,
	}),
	computed: {
		targetName() {
			return this.target?.fields?.type?.[this.defaultLocale]
		},
		metisId() {
			return this.target?.fields?.metisId?.[this.defaultLocale]
		},
	},
	watch: {
		value: {
			handler() {
				this.load()
			},
			deep: true,
		},
	},
	methods: {
		async loadSlaData(installationId, target, runner, interval, fromDate, toDate) {
			return await this.$httpPost('https://metis.alturos.com/etl/api/Zabbix/CalculateSla', {
				fromDate,
				toDate,
				interval,
				installationId,
				target,
				runner,
				// TODO: change to testcaseId once Andreas has changed the API
				testId: this.testcase.sys.id,
			})
		},
		async loadExecutionData(installationId, target, runner, fromDate, toDate) {
			const r = await this.$httpGet('https://autotest-zabbix-gw.tools.contenthub.dev/runner/execution', {
				fromDate,
				toDate,
				installationId,
				target,
				runner,
				testcaseId: this.testcase.sys.id,
				withAssets: true,
			})
			return r.results
		},
		getLeftPercent(time) {
			const start = new Date(this.slaData.actualStart).getTime()
			const end = new Date(this.slaData.actualEnd).getTime()
			const percent = (new Date(time).getTime() - start) / (end - start)
			return Math.round(percent * 1000) / 10
		},
		getHoverStyle(execution) {
			const left = this.getLeftPercent(execution.timestamp)
			if (left < 60) return { left: left + '%' }
			else return { right: (100 - left) + '%' }
		},
		isNight(time) {
			// fix timestamp to be in local time
			time = new Date(time).toLocaleString('en-US', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
			const hour = new Date(time).getHours()
			return hour < this.nightEnd || hour >= this.nightStart
		},
		async load() {
			this.slaData = await this.loadSlaData(this.metisId, this.targetName, this.runner, this.value.interval, this.value.fromDate, this.value.toDate)
			this.executionData = await this.loadExecutionData(this.metisId, this.targetName, this.runner, this.value.fromDate, this.value.toDate)
		},
		getExecutionSearchUrl(execution) {
			let fromDate = this.value.fromDate
			let toDate = this.value.toDate
			let url = `https://autotest-zabbix-gw.tools.contenthub.dev/?fromDate=${fromDate}&toDate=${toDate}&installationId=${this.metisId}&testId=${this.testcase.sys.id}&limit=50&withAssets=true`
			if (execution) url += `&id=${execution.id}`
			if (execution) url += `&executionId=${execution.executionId}`
			return url
		},
		showExecution(execution) {
			this.clickedExecution = execution
			this.$refs.results.open()
		},
		showExecutionSearch(event, execution = null) {
			event.stopPropagation()
			event.preventDefault()
			if (execution) {
				this.activeExecution = execution
			}
			console.log('open execution ui', execution)
			window.open(this.getExecutionSearchUrl(execution), '_blank')
		},
		openAsset(asset) {
			window.open(asset.url, '_blank')
		},
	},
	async mounted() {
		await this.load()
	},
}
